export default "__VITE_ASSET__Dk7G6M8G__"